import { createContext } from 'react';

/*
    Lets the chat thread track where the "New Messages" read marker is without
    reaching into the message tree. MBChatReadMarker registers its element here
    when it renders, and the thread uses it to decide whether to show the
    "n New Messages" button at the top of the viewport.
*/
export type RegisterReadMarker = (element: HTMLDivElement | null) => void;

export const ReadMarkerContext = createContext<RegisterReadMarker | null>(null);
